import { render, staticRenderFns } from "./studentMonthCalendar.vue?vue&type=template&id=1f6e889e&scoped=true&"
import script from "./studentMonthCalendar.vue?vue&type=script&lang=js&"
export * from "./studentMonthCalendar.vue?vue&type=script&lang=js&"
import style0 from "./studentMonthCalendar.vue?vue&type=style&index=0&id=1f6e889e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e889e",
  null
  
)

export default component.exports